import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Text, Link } from "@foris/avocado-suite";
import onboardingImage from "@assets/img/onboarding/chs-2858-past-sessions-onboarding.png";
import OnboardingVideoModal from "@common/components/onboarding-video-modal";
import { getTecPastSessionsOnboardingDetailsUrl } from "../../utils/getTecPastSessionsOnboardingDetailsUrl";
import { isTecPastSessionsOnboardingEligible } from "../../utils/isTecPastSessionsOnboardingEligible";
import {
  dismissTecPastSessionsOnboardingForUser,
  hasDismissedTecPastSessionsOnboarding,
} from "../../utils/tecPastSessionsOnboardingStorage";
import styles from "./tecPastSessionsOnboarding.module.scss";

interface TecPastSessionsOnboardingProps {
  userId?: string | null;
}

const TecPastSessionsOnboarding: FC<TecPastSessionsOnboardingProps> = ({ userId }) => {
  const { t } = useTranslation();
  const detailsUrl = getTecPastSessionsOnboardingDetailsUrl()?.trim();
  const [isOpen, setIsOpen] = useState(() =>
    isTecPastSessionsOnboardingEligible({
      hostname: window.location.hostname,
      now: new Date(),
      userId,
      hasDismissed: hasDismissedTecPastSessionsOnboarding(userId),
    }),
  );

  const handleClose = () => {
    dismissTecPastSessionsOnboardingForUser(userId);
    setIsOpen(false);
  };

  return (
    <OnboardingVideoModal
      isOpen={isOpen}
      title={t("onboarding.chs-2858.title")}
      header={
        <img
          className={styles.tecPastSessionsOnboarding_headerImage}
          src={onboardingImage}
          alt=""
        />
      }
      customContent={
        <Text type="lg">
          {t("onboarding.chs-2858.body")}
          {detailsUrl && (
            <Link
              href={detailsUrl}
              target="_blank"
              rel="noopener noreferrer"
              iconRight="external-link"
            >
              {` ${t("onboarding.chs-2858.details-link")}`}
            </Link>
          )}
        </Text>
      }
      actions={<Button onClick={handleClose}>{t("onboarding.chs-2858.confirmation")}</Button>}
      onClose={handleClose}
    />
  );
};

export default TecPastSessionsOnboarding;
